import React from 'react';

import { Modal } from '../../../../common/display/modal/Modal';
import { Benefit } from '../../../../../@types/benefits';
import type { BenefitModalProps } from '../../../../../@types/benefitModalProps';
import OpportunityCheckPng from './images/opportunity-check.png';
import OpportunityCheckWebp from './images/opportunity-check.webp';
import { useGetHasProduct } from '../../../../../customHooks/useGetHasProduct.hook';
import { ProductType } from '../../../../../@types/product';
import { Msg, useIntl } from '@/i18n';
import { PlusBadge } from '@/components/common/display/plusBadge/PlusBadge';

const styles = {
  overviewTab: { maxWidth: 530 },
};

const OverviewTab = () => {
  const isEntitledPlusRent = useGetHasProduct(ProductType.MieterPlus);

  return (
    <div style={styles.overviewTab}>
      <div className='padding-bottom-l font-body-large-regular'>
        <Msg
          id='benefits.opportunityCheckMieterPlus.modal.overview.paragraph1'
          defaultMessage='Good prospects? We show you...'
        />
      </div>

      <ul className='list-check list-spacing-m'>
        <li>
          <Msg
            id='benefits.opportunityCheckMieterPlus.modal.overview.point1'
            key='benefits.opportunityCheckMieterPlus.modal.overview.point1'
            defaultMessage='Analysis of demand'
          />
        </li>
        <li>
          <Msg
            id='benefits.opportunityCheckMieterPlus.modal.overview.point2'
            key='benefits.opportunityCheckMieterPlus.modal.overview.point2'
            defaultMessage='Your profile compared to the preferences of the landlords'
          />
        </li>
        <li>
          <Msg
            id='benefits.opportunityCheckMieterPlus.modal.overview.point3'
            key='benefits.opportunityCheckMieterPlus.modal.overview.point3'
            defaultMessage='Information about your competition'
          />
        </li>
        {!isEntitledPlusRent && (
          <li>
            <Msg
              id='benefits.opportunityCheckMieterPlus.modal.overview.activeMieterPlus'
              key='benefits.opportunityCheckMieterPlus.modal.overview.activeMieterPlus'
              defaultMessage='Included in Mieter Plus'
              values={{
                MieterPlusLogo: <PlusBadge variant='rent' />,
              }}
            />
          </li>
        )}
      </ul>
    </div>
  );
};

const ButtonArea = () => {
  return (
    <div className='align-center'>
      <a
        className='button-secondary button-rounded'
        href='/meinkonto/premium-mitgliedschaft/?cmp_id=10-051525&cmp_name=residential_profile&cmp_position=residential_benefits&cmp_creative=competition_analysis_cta'
      >
        <Msg id='benefits.opportunityCheckMieterPlus.modal.linkButton' defaultMessage='Discover Mieter Plus' />
      </a>
    </div>
  );
};

export const OpportunityCheckMieterPlus = ({ isVisible, onClose }: BenefitModalProps) => {
  const { t } = useIntl();
  const isEntitledPlusRent = useGetHasProduct(ProductType.MieterPlus);

  return (
    <Modal
      title={t({ id: 'benefits.opportunityCheckMieterPlus.headline', defaultMessage: 'Opportunity check' })}
      isVisible={isVisible}
      image={OpportunityCheckPng}
      imageWebp={OpportunityCheckWebp}
      imageUseFullWidth={false}
      imageAlt={t({
        id: 'benefits.opportunityCheckMieterPlus.modal.image',
        defaultMessage: 'phone with opportunity check preview',
      })}
      tabsContent={[<OverviewTab key='benefits.opportunityCheckMieterPlus.modal.overview' />]}
      benefit={Benefit.POSSIBILITY_CHECK}
      buttonArea={!isEntitledPlusRent ? <ButtonArea /> : null}
      onClose={onClose}
    />
  );
};
